import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../../app/theme';
import Rnd from './Rnd';

const useStyles = makeStyles(
  () => ({
    indexRoot: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    },
    index: {
      width: 24,
      height: 24,
      backgroundColor: color.$7,
      borderRadius: 50,
      textAlign: 'center',
      lineHeight: '24px',
      fontWeight: 500,
      color: color.$3,
      fontSize: 13,
    },
    delete: {
      display: 'none',
      position: 'absolute',
      top: 0,
      right: -159,
      padding: '3px 49px 4px 21px',
      borderRadius: 5,
      fontSize: 14,
      color: color.$6,
      opacity: 0.8,
      lineHeight: 'normal',
      '-webkit-backdrop-filter': 'blur(10px)',
      backdropFilter: 'blur(10px)',
      boxShadow:
        '0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 0 1px 0 rgba(0, 0, 0, 0.6)',
      backgroundColor: 'rgba(246, 246, 246, 0.9)',
      cursor: 'default',
      zIndex: 1000,
    },
  }),
  { name: 'MenuContentBox' },
);

export default function MenuContentBox({
  area,
  index,
  isSelect,
  onClick,
  maxWidth,
  maxHeight,
  minWidth,
  minHeight,
  removeAreaByIndex,
  setBounds,
  disabledDelete,
}) {
  const { t } = useTranslation();
  const deleteBtn = useRef();
  const { bounds } = area;
  const { x, y, width, height } = bounds;
  const classes = useStyles({ isSelect, width, height });

  useEffect(() => {
    const onKeyUp = eK => {
      if (
        isSelect &&
        !disabledDelete &&
        (eK.keyCode === 46 || eK.keyCode === 110)
      ) {
        removeAreaByIndex(index);
      }
    };
    document.addEventListener('keyup', onKeyUp);
    return () => {
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [index, isSelect]);

  const onResizeStop = (e, direction, ref) => {
    setBounds({
      index,
      bounds: {
        ...{ x, y },
        width: parseFloat(ref.style.width),
        height: parseFloat(ref.style.height),
      },
    });
  };

  const onDragStop = (e, deltaX, deltaY) => {
    setBounds({
      index,
      bounds: {
        ...{ width, height },
        x: deltaX,
        y: deltaY,
      },
    });
  };

  const onDelete = () => {
    removeAreaByIndex(index);
  };

  const onContextMenu = e => {
    e.preventDefault();
    onClick();
    const delBtns = document.getElementsByClassName('MenuContentBox-delete');
    for (let i = 0; i < delBtns.length; i += 1) {
      delBtns[i].style.display = 'none';
    }

    if (e.button === 2) {
      deleteBtn.current.style.display = 'block';
    } else {
      deleteBtn.current.style.display = 'none';
    }

    const onClose = () => {
      if (deleteBtn.current) deleteBtn.current.style.display = 'none';
      document.removeEventListener('click', onClose);
    };
    document.addEventListener('click', onClose);
  };

  return (
    <Rnd
      position={{ x, y }}
      size={{ width, height }}
      isSelect={isSelect}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      minWidth={minWidth}
      minHeight={minHeight}
      boundsId="MenuContent-content"
      onResizeStop={onResizeStop}
      onDragStop={onDragStop}
      onContextMenu={onContextMenu}
    >
      <div className={classes.indexRoot} onClick={onClick}>
        <div className={classes.index}>{index + 1}</div>
      </div>
      {!disabledDelete && (
        <div
          ref={deleteBtn}
          className={`${classes.delete} MenuContentBox-delete`}
          onClick={onDelete}
        >
          {t('templates.imagemap-edit.delete-area')}
        </div>
      )}
    </Rnd>
  );
}

MenuContentBox.defaultProps = {
  onClick: undefined,
  isSelect: false,
  area: {
    bounds: {
      x: 0,
      y: 0,
      width: 2500,
      height: 1686,
    },
    action: {},
  },
  size: {
    width: 2500,
    height: 1686,
  },
  index: 0,
  maxWidth: '100%',
  maxHeight: '100%',
  minWidth: 30,
  minHeight: 30,
};

MenuContentBox.propTypes = {
  onClick: PropTypes.func,
  isSelect: PropTypes.bool,
  area: PropTypes.shape({
    bounds: PropTypes.object,
    action: PropTypes.object,
  }),
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  index: PropTypes.number,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
